@if (state$ | async; as state) {
  @if (!state.isTier1DataLoaded) {
    <mat-spinner color="accent" />
  } @else {
    <ninety-main-layout
      [inMeeting]="state.inMeeting"
      [inFeedback]="state.inFeedback"
      [isMobile]="state.isMobile"
      [isConversation]="state.layoutType === layouts.conversation">
      <ng-container page-banner>
        @if (!(billingV3Company$ | ngrxPush)) {
          <ninety-notification-banner />
        }
      </ng-container>
      <ng-container billing-page-banner>
        @if (billingV3Company$ | ngrxPush) {
          <ninety-billing-notification-banner />
        }
      </ng-container>
      <ng-container subscription-renewal-banner>
        <ninety-subscription-renewal-banner />
      </ng-container>
      <ng-container manager-permission-changes-banner>
        <ninety-manager-permission-changes-banner />
      </ng-container>
      <ng-container page-sidebar>
        @switch (state.layoutType) {
          @case (layouts.meeting) {
            <ninety-meeting-sidenav-v2
              [showNav]="state.showSideNav"
              [isMobile]="state.isMobile"
              [showNotes]="state.showNotes" />
          }
          @case (layouts.conversation) {
            <ninety-conversation-sidenav
              [showNav]="state.showSideNav"
              [isMobile]="state.isMobile"
              [showQuarterlyQuestions]="state.showQuarterlyQuestions" />
          }
          @case ('normal') {
            <ninety-main-sidebar [isMobile]="state.isMobile" />
          }
        }
      </ng-container>
      <ng-container page-content>
        <router-outlet />
        @if (state.showNotes) {
          <ninety-meeting-notes [class.nav-expanded]="state.showSideNav" />
        }
      </ng-container>
    </ninety-main-layout>
  }
}
